import { JwtTokenFn } from "@me8eon/authentication";
import { CallInsights, getTrueDemApi } from "../../model/api";

export const getInsights = async (callId: string, trueDemApiTokenFn: JwtTokenFn): Promise<any> => {
    const path = `teams/calls/${callId}/data`;

    try {
        const response = await getTrueDemApi<CallInsights>(
            path,
            trueDemApiTokenFn
        );

        const insights = response.data;

        return insights ?? [];
    } catch (error) {
        console.error(`Error fetching insights for callId ${callId}:`, error);
        return [];
    }
};